export const landing = [
    {
        "body": "TechOpps is a non profit organization founded in the year 2020. It aims to deliver opportunites academically, professionally, and personally to passionate people in the tech industry.",
        "type": "info",
    },
    {
        "image": "https://res.cloudinary.com/rmkt/image/upload/v1597038564/techopps/hero_lltkd9.png",
        "title": "What We Believe In",
        "type": "value",
    },
    {
        "image": "https://res.cloudinary.com/rmkt/image/upload/v1597046350/techopps/TechOpps-TechTalks-Logo-Final_Main_Clear_b5uwqu.png",
        "title": "Series",
        "body": "Inspired from TED's mission of sharing ideas, TechTalks aims to invite speakers to share a story or an idea where viewers can learn from. TechTalks are hosted digitally where people can watch and ask questions to the speakers. We also post the recordings of these events on YouTube so that it could reach more people and impact more lives.",
        "type": "default",
    },
    {
        "image": "https://res.cloudinary.com/rmkt/image/upload/v1597040273/techopps/F44F22F1-ABEB-44B3-B30E-119C2FF40CD7_hgi63d.png",
        "title": "Don’t Miss Out!",
        "body": "Join TechOpps and enjoy member exclusive Perks, equip yourself to face challengers, and meet and learn from professionals!",
        "type": "button"
    },
    {
        "title": "Meet the Founders",
        "body": "We'd like to engage with you guys! Click through our photo to know more!",
        "type": "team"
    },
    {
        "title": "Contact Us",
        "body": "Want to partner with us? Feel free to reach out to any of our social media accounts!",
        "type": "contact"
    }
]